import { gql } from '@apollo/client'

import { DICTIONARY_WORDS_FRAGMENT } from '../fragments'

const DELETE_DICTIONARY_WORD_MUTATION = gql`
  mutation deleteDictionaryWord(
    $id: ID!
    $filters: DictionaryWordFiltersInput
    $page: Int
    $pageSize: Int
  ) {
    deleteDictionaryWord(
      id: $id
      filters: $filters
      page: $page
      pageSize: $pageSize
    ) {
      ...DictionaryWordsFragment
    }
  }
  ${DICTIONARY_WORDS_FRAGMENT}
`

export default DELETE_DICTIONARY_WORD_MUTATION
